(function () {
  'use strict';

  var grid = document.querySelector('.cs-grid');
  if (!grid) return;

  var items = Array.prototype.slice.call(grid.querySelectorAll('.cs-grid__item img'));
  if (!items.length) return;

  var lightbox = document.createElement('div');
  lightbox.className = 'cs-lightbox';
  lightbox.innerHTML =
    '<div class="cs-lightbox__backdrop"></div>' +
    '<button class="cs-lightbox__close" type="button" aria-label="Close">&times;</button>' +
    '<button class="cs-lightbox__prev" type="button" aria-label="Previous">&#8249;</button>' +
    '<div class="cs-lightbox__stage"><img class="cs-lightbox__img" alt=""></div>' +
    '<button class="cs-lightbox__next" type="button" aria-label="Next">&#8250;</button>' +
    '<div class="cs-lightbox__filmstrip"><div class="cs-lightbox__filmstrip-track"></div></div>';
  document.body.appendChild(lightbox);

  var imgEl      = lightbox.querySelector('.cs-lightbox__img');
  var backdropEl = lightbox.querySelector('.cs-lightbox__backdrop');
  var track      = lightbox.querySelector('.cs-lightbox__filmstrip-track');
  var index   = 0;
  var hideTimer = null;

  function setBackdrop(src) {
    backdropEl.style.backgroundImage = 'url(' + src + ')';
    backdropEl.classList.add('is-visible');
  }

  var thumbs = items.map(function (img, i) {
    var btn = document.createElement('button');
    btn.className = 'cs-lightbox__thumb';
    btn.type = 'button';
    var thumbImg = document.createElement('img');
    thumbImg.src = img.currentSrc || img.src;
    thumbImg.alt = '';
    btn.appendChild(thumbImg);
    btn.addEventListener('click', function () { show(i); });
    track.appendChild(btn);
    return btn;
  });

  function show(i) {
    index = (i + items.length) % items.length;
    imgEl.classList.add('is-fading');
    setTimeout(function () {
      var src = items[index].currentSrc || items[index].src;
      imgEl.src = src;
      imgEl.alt = items[index].alt || '';
      imgEl.classList.remove('is-fading');
      setBackdrop(src);
    }, 220);

    thumbs.forEach(function (t, i2) {
      t.classList.toggle('is-active', i2 === index);
    });
    thumbs[index].scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
  }

  function showControls() {
    lightbox.classList.add('controls-visible');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      lightbox.classList.remove('controls-visible');
    }, 2600);
  }

  function open(i) {
    var src = items[i].currentSrc || items[i].src;
    imgEl.src = src;
    imgEl.alt = items[i].alt || '';
    setBackdrop(src);
    index = i;
    thumbs.forEach(function (t, i2) {
      t.classList.toggle('is-active', i2 === index);
    });
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    showControls();
    requestAnimationFrame(function () {
      thumbs[index].scrollIntoView({ inline: 'center', block: 'nearest' });
    });
  }

  function close() {
    lightbox.classList.remove('is-open');
    lightbox.classList.remove('controls-visible');
    backdropEl.classList.remove('is-visible');
    clearTimeout(hideTimer);
    document.body.style.overflow = '';
  }

  items.forEach(function (img, i) {
    img.addEventListener('click', function () { open(i); });
  });

  lightbox.querySelector('.cs-lightbox__close').addEventListener('click', close);
  lightbox.querySelector('.cs-lightbox__prev').addEventListener('click', function () { show(index - 1); showControls(); });
  lightbox.querySelector('.cs-lightbox__next').addEventListener('click', function () { show(index + 1); showControls(); });

  lightbox.querySelector('.cs-lightbox__stage').addEventListener('click', function (e) {
    if (e.target === e.currentTarget) close();
  });

  lightbox.addEventListener('mousemove', showControls);
  lightbox.addEventListener('touchstart', showControls, { passive: true });

  var filmstrip = lightbox.querySelector('.cs-lightbox__filmstrip');
  filmstrip.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
  filmstrip.addEventListener('mouseleave', showControls);

  document.addEventListener('keydown', function (e) {
    if (!lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') { show(index - 1); showControls(); }
    if (e.key === 'ArrowRight') { show(index + 1); showControls(); }
  });

  // ── Touch swipe (next/prev, swipe-down to close) ────────
  var stage = lightbox.querySelector('.cs-lightbox__stage');
  var touchStartX = 0, touchStartY = 0, touchDX = 0, touchDY = 0, touching = false;

  stage.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) return;
    touching = true;
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    touchDX = 0;
    touchDY = 0;
  }, { passive: true });

  stage.addEventListener('touchmove', function (e) {
    if (!touching || e.touches.length !== 1) return;
    touchDX = e.touches[0].clientX - touchStartX;
    touchDY = e.touches[0].clientY - touchStartY;
  }, { passive: true });

  stage.addEventListener('touchend', function () {
    if (!touching) return;
    touching = false;

    var absX = Math.abs(touchDX);
    var absY = Math.abs(touchDY);
    var SWIPE_THRESHOLD = 50;

    if (absX > absY && absX > SWIPE_THRESHOLD) {
      if (touchDX < 0) { show(index + 1); } else { show(index - 1); }
      showControls();
    } else if (absY > absX && touchDY > 90) {
      close();
    }
  });
})();
